import { type IIconButton } from './types'
import styles from './styles.module.css'

export function IconButton ({ icon, onClick, className }: IIconButton) {
  return <div className={styles.IconButton + ' ' + className} onClick={onClick}>
        <img className={styles.Icon} src={icon} alt={'no'}/>
    </div>
}
